import createReducer from 'data/shared/createReducer';
import { SUBMITTING_FIRST_SIGN_IN, REQUEST_FIRST_SIGN_IN, FIRST_SIGN_IN_SUCCESS, FIRST_SIGN_IN_FAILURE, RESET_FIRST_SIGN_IN } from '../constants/action_types';

const initialState = {
    error: null,
    isLoading: false,
    success : false
};

const submittingFirstSignIn = (state, action) => ({
    ...initialState
});

const requestFirstSignIn = (state, action) => ({
    ...state,
    isLoading: true
});

const firstSignInSuccess = (state, action) => ({
    ...state,
    error: null,
    isLoading: false, 
    success: true
});

const firstSignInFailure = (state, action) => ({
    ...state,
    error: 'error',
    isLoading: false
});

const resetFirstSignIn = (state, action) => ({
    ...initialState
});

const firstSignInReducer = createReducer(initialState, {
    [SUBMITTING_FIRST_SIGN_IN]: submittingFirstSignIn,
    [REQUEST_FIRST_SIGN_IN]: requestFirstSignIn,
    [FIRST_SIGN_IN_SUCCESS]: firstSignInSuccess,
    [FIRST_SIGN_IN_FAILURE]: firstSignInFailure,
    [RESET_FIRST_SIGN_IN]: resetFirstSignIn
});

export default firstSignInReducer;
